module.exports = __webpack_public_path__ + "img/thumbnail_RedCrownedCrane_f_normal.db774a52.png";